import apiClient from '@/services/api_client';

export type TenantCapability =
    | 'publish_public_theme'
    | 'publish_public_document'
    | 'publish_public_datasource'
    | 'publish_public_custom_agent'
    | 'publish_public_project'
    | 'share_project'
    | 'create_private_theme'
    | 'create_datasource'
    | 'view_quota';

/** Who holds a capability. `nobody` takes it from admins too. */
export type CapabilityAudience = 'nobody' | 'admins' | 'members';

export type CapabilityAudiences = Record<TenantCapability, CapabilityAudience>;

/** Mirrors the backend's CAPABILITY_DEFAULT_AUDIENCE. */
export const DEFAULT_CAPABILITY_AUDIENCES: CapabilityAudiences = {
    publish_public_theme: 'admins',
    publish_public_document: 'admins',
    publish_public_datasource: 'admins',
    publish_public_custom_agent: 'admins',
    publish_public_project: 'admins',
    share_project: 'members',
    create_private_theme: 'members',
    create_datasource: 'members',
    view_quota: 'members'
};

/** Hand a capability to an audience; returns every capability's audience. */
export async function setTenantCapability(
    tenantId: string,
    capability: TenantCapability,
    audience: CapabilityAudience
): Promise<CapabilityAudiences> {
    return await apiClient.post('/tenant_capabilities', {
        tenant_id: tenantId,
        capability,
        audience
    });
}
